/**
* Interactive Gallery JS
* -----------------------------------------------------------------------------
*
* All the JS for the Interactive Gallery component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'interactive-gallery',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.interactive-gallery' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--interactive-gallery' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '20px',
          perPage: 2,
          perMove: 1,
          breakpoints: {
            768: {
              perPage: 1,
            },
          },
        } );

        splide.mount();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 75%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( component ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( component ).addClass( 'is-loaded' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'interactive-gallery', COMPONENT );
} )( app );
